<template>
   <div v-title="pageTitle" class="container">
         <div> 
            <van-tabs sticky @change="change">
               <van-tab v-for="(items,index) in tabs" :title="items" :key="index">
                  <van-loading size="24px" v-show="loading"  vertical style="padding-top: 300px;">加载中...</van-loading>
                  <div class="empty" v-if="list.length==0&&!loading">暂无数据</div>
                  <div> 
                     <div v-for="(items,index) in list" :key="index">
                         <div class="cont"> 
                            <div class="times">{{ items.addTime }}</div>
                            <div class="upcont"> 
                               <div class="flx"> 
                                  <div class="sz">售后单号: </div>
                                  <div class="sz1">{{ items.aftersaleSn }}</div>
                               </div>
                               <div class="flx mt"> 
                                  <div class="sz">售后类型: </div>
                                  <div class="sz1 s3">{{ type[items.type] }}</div>
                               </div>
                               <div class="flx mt"> 
                                  <div class="sz">退款原因: </div>
                                  <div class="sz1">{{ items.reason }}</div>
                               </div>
                               <div class="flx mt"> 
                                  <div class="sz">退款价格: </div>
                                  <div class="sz1">¥ {{ items.amount }}</div>
                               </div>
                               <div class="flx mt" v-if="items.pictures.length!=0"> 
                                  <div class="sz">退款凭证: </div>
                                  <div class="sz1"> </div>
                               </div>
                               <div class="flx"> 
                                  <div v-for="(itm,idx) in items.pictures" :key="idx"> 
                                    <img :src="itm" style="width: 60px;height: 60px; padding: 5px; border-radius: 5px;" @click.stop="imgs(index,idx)" />  
                                 </div>
                               </div>
                               <div class="flx" style="justify-content: right;"> 
                                 <van-button size="small" type="primary" v-if="items.status==1" round style="margin-right: 10px;" @click.stop="Event(0,index)">同意</van-button>
                                 <van-button size="small" type="danger" v-if="items.status==1" round @click.stop="Event(1,index)">拒绝</van-button>
                                 <van-button size="small" type="warning" v-if="items.status==2" round @click.stop="Event(2,index)">退款</van-button>
                               </div>
                            </div>
                         </div>
                     </div>
                  </div>
               </van-tab>
            </van-tabs>
         </div>
         <div style="padding-top: 10px;padding-bottom: 20px;" v-if="total>10"> 
           <van-pagination v-model="currentPage" :total-items="total" :items-per-page="per" @change="pagesChange" />
       </div>
   </div>
</template>

<script>
import { ImagePreview } from 'vant'
import request from '../api/request';
export default {
   data(){
    return{
        pageTitle:'售后管理',list:[],tabs:['全部','待审核','待退款'],loading:true,type:['未收货退款','不退货退款','退货退款'],
        currentPage:1,total:0,per:10
    }
   },
   mounted(){
     this.loaddata()
   },
   methods:{
      loaddata(){
         request.getcommerlist({},'/admin/aftersale/list','get',localStorage.getItem('token_yr'),res=>{
            if(res.errno==0){
                this.firstData=res.data.list
                this.total=JSON.parse(JSON.stringify(this.firstData))
                this.list=res.data.list
               //  console.log(res)
               this.loadlist()
            }
            this.loading=false
         })
      },
      pagesChange(e){
            this.currentPage=e
            this.loadlist()
            console.log(e)
        },
        loadlist(){
            this.list=JSON.parse(JSON.stringify(this.firstData))
            this.list=this.list.slice((this.currentPage-1)*10,this.currentPage*10)
        },
      change(index){
            this.currentPage=1
            const list=JSON.parse(JSON.stringify(this.firstData))
            if(index==0) {
                this.total=JSON.parse(JSON.stringify(this.firstData)).length
                this.list=list
            }
            else {
                this.list=list.filter(item=>{return item.status==index})
                this.total=JSON.parse(JSON.stringify(list))
                this.list=this.list.slice((this.currentPage-1)*10,this.currentPage*10)
            }
      },
      imgs(i,e){
         // console.log(this.list)
         ImagePreview({
             images: [this.list[i].pictures[e]],
             closeable: true,
             startPosition:0
          });
      },
      Event(e,i){
         // console.log(this.list[i].orderId)
         const parms={id:this.list[i].id}
         var url=''
         switch(e){
            //同意
            case 0:
              url='/admin/aftersale/recept'
               break;
               //拒绝
            case 1:
              url='/admin/aftersale/reject'
            break;
            //退款
            case 2:
            url='/admin/aftersale/refund'
               break;
         }
         this.$dialog.alert({
                 title:'提示',
                 message: e==0?'同意申请退款？':''||e==1?'拒绝退款？':''||e==2?'同意退款？':'',
                 showCancelButton:true,
               }).then(() => {
                request.getcommerlist(parms,url,'post',localStorage.getItem('token_yr'),res=>{
                if(res.errno==0){
                  //   this.$router.back()
                  var obj=JSON.parse(JSON.stringify(this.list[i]))
                  obj.status=e==2?3:0||e==1?4:0||e==0?2:0
                  this.$set(this.list,i,obj)
                  this.$set(this.firstData,i,obj)
                }
                this.$toast(res.errmsg)
                })
             });
      }
   }
}
</script>

<style scoped lang="less">
.container{
   background: #eeeded;
    height: 100%;
    width: 100%;
    overflow: scroll;

}
.empty{width: 100%;text-align: center;margin-top: 55%;color: #959494;font-size: 15px;}
.times{width: 100%;text-align: center; font-size: 12px;color: #605f5f;}
.cont{padding: 10px;}
.flx{display: flex; align-items: center;}
.upcont{
   padding: 10px;
   background: #fff;
   border-radius: 5px;
   margin-top:5px
}
.sz{font-size: 14px; color: #a5a5a5;}
.sz1{font-size: 14px; margin-left: 20px;}
.s3 {
    color: #fdc33b;
    padding: 2px;
    background: #f6f3c3;
    border: #fdc33b solid 1px;
    border-radius: 5px;
    font-size: 12px;
}
.mt{margin-top: 5px;}
</style>